import { ref } from 'vue'

import msgOpen from './customUpdateMsg'

const useFetchETagFunc = () => {
  const eTag = ref()
  const needUpdatePage = ref(false)

  // 轮询间隔
  const pollingInterval = 60 * 1000

  const fetchETag = async () => {
    const response = await fetch(`/?t=${new Date().getTime()}`, {
      cache: 'no-cache',
      method: 'HEAD',
    })
    return response.headers.get('ETag')
  }

  const pollingETag = async () => {
    const newETag = await fetchETag()
    needUpdatePage.value = newETag !== eTag.value

    if (!needUpdatePage.value) {
      setTimeout(() => {
        pollingETag()
      }, pollingInterval)
    } else {
      // 更新了
      msgOpen('新版本更新，请务必刷新页面', '立即刷新')
    }

    eTag.value = newETag
  }

  const initETag = async () => {
    eTag.value = await fetchETag()

    pollingETag()
  }

  return {
    initETag,
  }
}

export default useFetchETagFunc
